<template>
  <v-container fluid class="down-top-padding">
    <BaseBreadcrumb
      :title="this.$vuetify.lang.t('$vuetify.REPORTS.TITLE')"
      :breadcrumbs="[
        {
          text: this.$vuetify.lang.t('$vuetify.REPORTS.DESCRIPTION'),
          disabled: true
        }
      ]"
    ></BaseBreadcrumb>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-tabs v-model="selectedPage">
            <v-tab
              v-if="
                user.isAdmin ||
                  (user.isPlaceAdmin && !user.isWhitelistManager) ||
                  isGlobalAdmin ||
                  user.isPlaceAdmin
              "
            >
              Payout
            </v-tab>
            <v-tab
              v-if="
                user.isAdmin || user.isPlaceAdmin || user.isWhitelistManager
              "
            >
              {{ $vuetify.lang.t('$vuetify.WHITELISTS.TITLE') }}
            </v-tab>
            <v-tab>
              {{ $vuetify.lang.t('$vuetify.FLEETS.TITLE') }}
            </v-tab>
            <!-- Payout -->
            <v-tab-item
              v-if="
                user.isAdmin ||
                  (user.isPlaceAdmin && !user.isWhitelistManager) ||
                  isGlobalAdmin ||
                  user.isPlaceAdmin
              "
            >
              <payout-report />
            </v-tab-item>
            <!-- Whitelists -->
            <v-tab-item
              v-if="
                user.isAdmin || user.isPlaceAdmin || user.isWhitelistManager
              "
            >
              <whitelist-report />
            </v-tab-item>
            <!-- Fleets -->
            <v-tab-item>
              <fleet-report />
            </v-tab-item>
          </v-tabs>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Reports',
  components: {
    WhitelistReport: () =>
      import(
        /* webpackChunkName: "WhitelistReport" */ '@/components/reports/WhitelistReport'
      ),
    FleetReport: () =>
      import(
        /* webpackChunkName: "FleetReport" */ '@/components/reports/FleetReport'
      ),
    PayoutReport: () =>
      import(
        /* webpackChunkName: "PayoutReport" */ '@/components/reports/PayoutReport'
      )
  },
  data() {
    return {
      selectedPage: ''
    }
  },
  computed: {
    ...mapGetters('authentication', ['user', 'isGlobalAdmin'])
  }
}
</script>
